export default __webpack_public_path__ + "static/corsica-credit-Alessandro-Valli-9ed5d2e0e8c7ea9cd72e81f5ac56aa83.jpg";